import type { ReactNode } from 'react';

interface DetailCardProps {
  // No @types/react in this project, so `key` is not provided by
  // JSX.IntrinsicAttributes and must be declared for list rendering.
  key?: string;
  title: string;
  icon: ReactNode;
  children: ReactNode;
}

// The white card with a gradient header used on the ticket detail pages.
const DetailCard = ({ title, icon, children }: DetailCardProps) => (
  <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
    <div className="px-6 py-4 bg-gradient-to-r from-gray-50 to-white border-b border-gray-200">
      <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
        {icon}
        {title}
      </h3>
    </div>
    <div className="p-6">{children}</div>
  </div>
);

export default DetailCard;
